<template>
  <v-card>
    <v-card-title primary-title style="margin: 0;padding: 0;">
      <v-subheader>{{header}}</v-subheader>
    </v-card-title>
    <v-container grid-list-md fluid ma-0 pa-0 pl-3 pr-3>
      <v-layout row wrap>
        <v-flex xs3>
          <v-text-field v-model="title.text" name="text" label="标题" hint="text"></v-text-field>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete v-model="title.align" :items="['left','center','right']" label="水平对齐方式" hint="align">
          </v-autocomplete>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
  import {
    Title
  } from "./options.ts";
  export default Title;
</script>